import React from "react";
import "./App.css";
import SortingVisualizer from "./components/SortingVisualizer";

function App() {
  return (
    <div className="app">
      <SortingVisualizer />
    </div>
  );
}

export default App;
